import * as React from "react";
const SvgNotification = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M12 13.1962C11.4637 13.1962 10.9275 13.0815 10.4288 12.8512L3 9.42225V18C3 18.8287 3.67125 19.5 4.5 19.5H19.5C20.3288 19.5 21 18.8287 21 18V9.42225L13.5712 12.8512C13.0725 13.0815 12.5363 13.1962 12 13.1962ZM19.5 4.5H4.5C3.67125 4.5 3 5.17125 3 6V7.77L11.0573 11.4885C11.6565 11.7645 12.3443 11.7652 12.9435 11.4885L21 7.77V6C21 5.17125 20.3288 4.5 19.5 4.5Z",
	fill: "#161845"
}));
export default SvgNotification;
